// extracted by mini-css-extract-plugin
export default {"staticWidget":"styles_staticWidget__yAeTU"};